export const SLACK_URL = 'https://community.livecycle.io'
